import React, {useEffect, useState} from 'react';
import {useZooPassAppContext} from "../../Context/ZooPassAppContext";
import classNames from 'classnames';
import {PassSelectCardBenefit} from "./PassSelectCardBenefit";
import {ZooPassContribIdItem, ZooPassOfferingItem, ZooPassOfferingYearSetItem} from "../../Data/ZooContrib";
import ZooPassStepDataUtility from "../../Utilities/ZooPassStepDataUtility";

export interface PassSelectCardSummary {
    adults: 1 | 2;
    children: 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | boolean;
    guests: 0 | 1 | 2 | 3 | 4;
    parking: boolean;
    additional: number;
    education: boolean;
    behindScenes: boolean;
}

export interface PassSelectCardProps {
    membership: ZooPassOfferingItem;
    summary: PassSelectCardSummary;
    isGift: boolean;
    yearNumber: 1 | 2 | 3;
    isRecommended: boolean;
    onClick?: () => void;
    onKeyboardPress?: (event : any) => void;
}

const tabIndex = -1;


export const PassSelectCard: React.FC<PassSelectCardProps> = ({membership, summary, isGift, yearNumber, isRecommended, onClick, onKeyboardPress}) => {
    let {
        dictionary,
        loading
    } = useZooPassAppContext();

    const [selected, setSelected] = useState<boolean>(false);
    
    const[priceHtml, setPriceHtml] = useState("");
    useEffect(() => {
        if(loading || !dictionary || !membership){
            setPriceHtml("");
            return;
        }
        const rawText = dictionary.get("ZooPass:StepLayout:07:FromPerYear");
        if(!rawText){
            setPriceHtml("");
            return;
        }
        setPriceHtml(rawText.replace("{0}", Math.trunc(ZooPassStepDataUtility.GetMembershipId(membership, isGift, yearNumber).amount).toString()));
    }, [membership, loading, dictionary]);

    const selectedClick = () => {
        setSelected(true);
        onClick && onClick();
    }

    return (
        <div className="col zoopass--pass-card-wrapper">
            <div
                className={classNames("card", "w-100", "card--membership", "h-100", { "is-recommended": isRecommended || selected })}>
                <div className={classNames("card-header", {"card__recommended": isRecommended}, {"card__upgrade": !isRecommended})}>
                    <span className={classNames("text--bold", "small", {"d-none": !isRecommended})}>
                        {dictionary.get("ZooPass:StepLayout:07:Recommended")}
                    </span>
                    <span className={classNames("text--bold", "small", {"d-none": isRecommended})}>
                        {dictionary.get("ZooPass:StepLayout:07:Upgrade")}
                    </span>
                </div>
                <div className="card-body__featured px-3 pt-3">
                    <h3>{membership.title}</h3>
                    <p dangerouslySetInnerHTML={{__html: priceHtml}}></p>
                </div>
                <div className="card-body card__header">
                    <ul className="list-group list-group-flush ms-0 ps-0">
                        <li className="list-group-item benefit">
                            <PassSelectCardBenefit key="benefit_adult" fetchKey="ZooPass:Summary:Adult"
                                                   imgAlt="Adult Icon"
                                                   value1={summary.adults}/>
                        </li>
                        <li className="list-group-item benefit">
                            <PassSelectCardBenefit key="benefit_children" fetchKey="ZooPass:Summary:Minor"
                                                   imgAlt="Minor Icon" value1={summary.children}/>
                        </li>
                        <li className="list-group-item benefit">
                            <PassSelectCardBenefit key="benefit_guests" fetchKey="ZooPass:Summary:Guest"
                                                   imgAlt="Guests Icon" value1={summary.guests}/>
                        </li>
                        <li className="list-group-item benefit">
                            <PassSelectCardBenefit key="benefit_guests" fetchKey="ZooPass:Summary:Parking"
                                                   imgAlt="Guests Icon" value1={summary.parking ? 1 : 0}/>
                        </li>
                        <li className={classNames("list-group-item", "benefit", {"d-none": summary.additional == 0})}>
                            <PassSelectCardBenefit key="benefit_additional" fetchKey="ZooPass:Summary:AdditionalGuests"
                                                   imgAlt="Additional Guests Icon" value1={summary.additional}/>
                        </li>
                        <li className={classNames("list-group-item", "benefit", {"d-none": !summary.education})}>
                            <PassSelectCardBenefit key="benefit_education" fetchKey="ZooPass:Summary:Education"
                                                   imgAlt="Education Class Certificate Icon"
                                                   value1={summary.education ? 1 : 0}/>
                        </li>
                        <li className={classNames("list-group-item", "benefit", {"d-none": !summary.behindScenes})}>
                            <PassSelectCardBenefit key="benefit_behind_the_scenes"
                                                   fetchKey="ZooPass:Summary:BehindScenes"
                                                   imgAlt="Education Class Certificate Icon"
                                                   value1={summary.behindScenes ? 1 : 0}/>
                        </li>
                    </ul>
                </div>
                <div className="card-footer">
                    <button className="btn btn-default w-100 border-2 border-black rounded-0 zoopass--step8--choose-pass-button"
                            onClick={onClick} onKeyUpCapture={onKeyboardPress}>{dictionary?.get("ZooPass:StepLayout:07:ChooseThisPass")}</button>
                </div>
            </div>
        </div>
    );
}